import $api from '../../utils/api.js'


const state = () => ({
    website_list: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Website'
    },
    formwebsite:{
        id:'',
        user_id:'',
        name:'',
        domain:'',
        logo:'',
        phone:'',
        email:'',
        whatsapp:'',
        address:'',
        sosmed:'',
        expired_date:'',
        is_active:'true',
    },

    website: {},
    errors:[],

    formpricelist:{
        id:'',
        name:'',
        label:'',
        include:'',
        exclude:'',
        price:null,
        price_discount:null,
        is_spesial:'false',
        link_tema:'',
        link_book:'',
    },
    formfaq:{
        id:'',
        title:'',
        desc:'',
    },
    formfeatured:{
        id:'',
        name:'',
        desc:'',
    },
    formtestimonial:{
        id:'',
        title:'',
        desc:'',
        name:'',
        job:'',
        photo:'',
    },
    formtema:{}

})

const mutations = {
    ASSIGN_DATA_WEBSITE_LIST(state, payload) {
        state.website_list = payload
    },
    ASSIGN_FORM_WEBSITE_LIST(state,paylaod){
        state.formwebsite = {
            id:paylaod.id,
            user_id:paylaod.user_id,
            name:paylaod.name,
            domain:paylaod.domain,
            logo:paylaod.logo,
            phone:paylaod.phone,
            email:paylaod.email,
            whatsapp:paylaod.whatsapp,
            address:paylaod.address,
            sosmed:paylaod.sosmed,
            expired_date:paylaod.expired_date,
            is_active:paylaod.is_active,
        }
    },
    CLEAR_FORM_WEBSITE_LIST(state){
        state.formwebsite = {
            id:'',
            user_id:'',
            name:'',
            domain:'',
            logo:'',
            phone:'',
            email:'',
            whatsapp:'',
            address:'',
            sosmed:'',
            expired_date:'',
            is_active:'true',
        }
    },

    ASSIGN_DATA(state, payload) {
        state.website = payload
    },

    // PRICELIST
    ////////////
    SET_POSITION_PRICELIST(state, payload) {
        state.website.pricelist = payload
    },
    ASSIGN_FORM_PRICELIST(state, payload){
        state.formpricelist = {
            id:payload.id,
            name:payload.name,
            label:payload.label,
            include:payload.include,
            exclude:payload.exclude,
            price:payload.price,
            price_discount:payload.price_discount,
            is_spesial:payload.is_spesial,
            link_tema:payload.link_tema,
            link_book:payload.link_book,
        }
    },
    CLEAR_FORM_PRICELIST(state){
        state.formpricelist = {
            id:'',
            name:'',
            label:'',
            include:'',
            exclude:'',
            price:null,
            price_discount:null,
            is_spesial:'false',
            link_tema:'',
            link_book:'',
        }
    },

    // FAQ
    ////////////
    SET_POSITION_FAQ(state, payload) {
        state.website.faq = payload
    },
    ASSIGN_FORM_FAQ(state, payload){
        state.formfaq = {
            id:payload.id,
            title:payload.title,
            desc:payload.desc,
        }
    },
    CLEAR_FORM_FAQ(state){
        state.formfaq = {
            id:'',
            title:'',
            desc:'',
        }
    },

    // FEATURED
    ////////////
    SET_POSITION_FEATURED(state, payload) {
        state.website.featured = payload
    },
    ASSIGN_FORM_FEATURED(state, payload){
        state.formfeatured = {
            id:payload.id,
            name:payload.name,
            desc:payload.desc,
        }
    },
    CLEAR_FORM_FEATURED(state){
        state.formfeatured = {
            id:'',
            name:'',
            desc:'',
        }
    },

    // TESTIMONIAL
    ////////////
    SET_POSITION_TESTIMONIAL(state, payload) {
        state.website.testimonial = payload
    },
    ASSIGN_FORM_TESTIMONIAL(state, payload){
        state.formtestimonial = {
            id:payload.id,
            title:payload.title,
            desc:payload.desc,
            name:payload.name,
            job:payload.job,
            photo:payload.photo,
        }
    },
    CLEAR_FORM_TESTIMONIAL(state){
        state.formtestimonial = {
            id:'',
            title:'',
            desc:'',
            name:'',
            job:'',
            photo:'',
        }
    },

    // TEMA
    ////////////
    SET_POSITION_TEMA(state, payload) {
        state.website.tema = payload
    },
    ASSIGN_FORM_TEMA(state, payload){
        state.formtema = payload
    },
    CLEAR_FORM_TEMA(state){
        state.formtema = {}
    },
}

const actions = {
    getWebsiteList({ commit, state }) {
        var page = state.sorting.search ? 1 : state.website_list.current_page

        return new Promise((resolve) => {
            $api.get(`website-list?page=${page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA_WEBSITE_LIST', response.data)
                resolve(response.data)
            })
        })
    },
    createWebsiteList(_, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website-list`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateWebsiteList({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website-list/${state.formwebsite.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteWebsiteList({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`website-list/${payload}`)
            .then(() => {
                dispatch('getWebsiteList').then(() => resolve())
            })
        })
    },
  

    //WEBSITE
    getWebsite({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.get(`website/${payload}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //SETTINGS
    updateSettings({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/settings/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
   

    //PRICELIST
    createPricelist({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/pricelist/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePricelist({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/pricelist/${state.formpricelist.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deletePricelist(_, payload) {
        return new Promise((reject) => {
            $api.delete(`website/pricelist/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionPricelist({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/position/pricelist/${state.website.id}`, {pricelist:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //FAQ
    createFaq({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/faq/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateFaq({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/faq/${state.formfaq.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteFaq(_, payload) {
        return new Promise((reject) => {
            $api.delete(`website/faq/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionFaq({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/position/faq/${state.website.id}`, {faq:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //FEATURED
    createFeatured({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/featured/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateFeatured({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/featured/${state.formfeatured.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteFeatured(_, payload) {
        return new Promise((reject) => {
            $api.delete(`website/featured/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionFeatured({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/position/featured/${state.website.id}`, {featured:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //TESTIMONIAL
    createTestimonial({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/testimonial/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateTestimonial({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/testimonial/${state.formtestimonial.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteTestimonial(_, payload) {
        return new Promise((reject) => {
            $api.delete(`website/testimonial/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionTestimonial({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/position/testimonial/${state.website.id}`, {testimonial:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //TEMA
    activateTema({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`website/tema/activate/${state.website.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateTema({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/tema/${state.formtema.web_tema_id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionTema({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`website/position/tema/${state.website.id}`, {tema:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}